import React, { FC } from 'react'

interface Props {
  onMouseLeave: () => void
  onMouseOver: () => void
}

export const GroupMembersDropdownArrowIcon: FC<Props> = ({ onMouseOver, onMouseLeave }) => (
  <div
    style={{
      cursor: 'pointer',
      position: 'relative',
      top: '6px',
      left: 0,
      width: 0,
      height: 0,
      borderRadius: '2px',
      borderLeft: '5px solid transparent',
      borderRight: '5px solid transparent',
      borderTop: '5px solid rgba(41, 52, 61, 0.32)',
    }}
    data-chili-css='group-members-dropdown-arrow'
    onMouseOver={onMouseOver}
    onMouseLeave={onMouseLeave}
  ></div>
)
